import { ACOES_POR_ID } from './catalogoAcoes'
import type { EstadoVitimaNaSessao, IdAcaoAvaliacao } from './tipos'

/** A impressão externa precisa ser examinada; abrir a ficha ou identificar a vítima não basta. */
export const ACOES_ABORDAGEM: readonly IdAcaoAvaliacao[] = [
  'chegada_queixa_aparencia', 'chegada_instrucao_ator',
]

export const ACOES_XABCDE_INICIAL: readonly IdAcaoAvaliacao[] = [
  'x_hemorragia_externa', 'a_permeabilidade_via_aerea', 'b_expansao_toracica',
  'c_pulso_radial', 'd_nivel_avdi', 'e_exposicao_dorso',
]

/** Exige leitura real de exame/avaliação primária, inclusive externa; SAMPLE isolado não habilita. */
export function podeClassificarVitima(estado: EstadoVitimaNaSessao): boolean {
  return estado.leituras.some(({ idAcao, achado }) => {
    const etapa = ACOES_POR_ID[idAcao]?.etapa
    return achado.estado !== 'nao_informado' &&
      (etapa === 'impressao_geral' || ['X', 'A', 'B', 'C', 'D', 'E'].includes(etapa))
  })
}

export function comunicacaoEquipeRegistrada(estado: EstadoVitimaNaSessao): boolean {
  const comunicacao = [...estado.intervencoesRealizadas].reverse().find(i => i.tipo === 'comunicacao_equipe')
  return Boolean(estado.triagemDeclarada && comunicacao &&
    comunicacao.parametros.classificacao === estado.triagemDeclarada &&
    comunicacao.parametros.justificativa === (estado.justificativaTriagem ?? ''))
}
